var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCardHelp02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6563 43.3527H28.5483C27.9351 43.3527 27.4375 42.8343 27.4375 42.1956C27.4375 41.5569 27.9351 41.0385 28.5483 41.0385H38.5455V37.5672C38.5455 36.9285 39.0432 36.4102 39.6563 36.4102C40.2695 36.4102 40.7671 36.9285 40.7671 37.5672V42.1956C40.7671 42.8343 40.2695 43.3527 39.6563 43.3527",
    fill: "#FF7F37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1049 41.0383C23.4917 41.0383 22.9941 41.559 22.9941 42.1954C22.9941 42.8318 23.4917 43.3525 24.1049 43.3525H26.3265C26.9396 43.3525 27.4373 42.8318 27.4373 42.1954C27.4373 41.559 26.9396 41.0383 26.3265 41.0383H24.1049ZM26.3265 45.6666H24.1049C22.2676 45.6666 20.7725 44.1092 20.7725 42.1954C20.7725 40.2816 22.2676 38.7241 24.1049 38.7241H26.3265C28.1637 38.7241 29.6589 40.2816 29.6589 42.1954C29.6589 44.1092 28.1637 45.6666 26.3265 45.6666V45.6666Z",
    fill: "#F5B6CD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_512_5078",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 21,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66504 4H29.8165V24.8391H9.66504V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_512_5078)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7758 24.8394C10.1627 24.8394 9.66504 24.321 9.66504 23.6823V20.211C9.66504 18.8896 9.82055 17.5705 10.1249 16.2931C11.1291 12.0929 13.6417 8.55221 17.2029 6.32366C20.762 4.09511 24.9408 3.4402 28.973 4.48621C29.5684 4.63894 29.9305 5.2684 29.7839 5.8886C29.635 6.5088 29.0352 6.88138 28.4354 6.73096C21.3063 4.87962 14.0549 9.42002 12.2821 16.8508C12.0199 17.9477 11.8866 19.0771 11.8866 20.211V23.6823C11.8866 24.321 11.389 24.8394 10.7758 24.8394",
    fill: "#00C389"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6562 24.8393C39.043 24.8393 38.5454 24.3209 38.5454 23.6822V20.211C38.5454 13.8077 34.3888 8.26521 28.4371 6.73092C27.8439 6.57818 27.4796 5.95104 27.6262 5.33084C27.7728 4.71296 28.3682 4.33575 28.9703 4.48617C35.915 6.27503 40.767 12.7408 40.767 20.211V23.6822C40.767 24.3209 40.2693 24.8393 39.6562 24.8393",
    fill: "#00CCEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5458 36.4099H41.8782C43.7155 36.4099 45.2106 34.8525 45.2106 32.9387V28.3103C45.2106 26.3965 43.7155 24.8391 41.8782 24.8391H38.5458V36.4099ZM41.8782 38.7241H37.435C36.8219 38.7241 36.3242 38.2057 36.3242 37.567V23.682C36.3242 23.0433 36.8219 22.5249 37.435 22.5249H41.8782C44.9418 22.5249 47.4322 25.1214 47.4322 28.3103V32.9387C47.4322 36.1299 44.9418 38.7241 41.8782 38.7241V38.7241Z",
    fill: "#9063CD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55401 24.8391C6.71675 24.8391 5.22161 26.3965 5.22161 28.3103V32.9387C5.22161 34.8525 6.71675 36.4099 8.55401 36.4099H11.8864V24.8391H8.55401ZM12.9972 38.7241H8.55401C5.49264 38.7241 3 36.1299 3 32.9387V28.3103C3 25.1214 5.49264 22.5249 8.55401 22.5249H12.9972C13.6104 22.5249 14.108 23.0433 14.108 23.682V37.567C14.108 38.2057 13.6104 38.7241 12.9972 38.7241V38.7241Z",
    fill: "#FDDA24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardHelp02);
export default __webpack_public_path__ + "static/media/icon_card_help_02.7c2bcf9787614e5bd2c6c5ceedbf0072.svg";
export { ForwardRef as ReactComponent };